export default {
	methods: {
		formatString: function (s: string) {
			const args = Array.prototype.slice.call(arguments, 1);
			return s.replace(/{(\d+)}/g, function (match, n) {
				return typeof args[n] !== 'undefined'
					? args[n]
					: match
					;
			});
		}
	}
};
